import React from 'react'
import styled from 'styled-components'

import gifCarouselSrc from '@/assets/video/grid-cc-final.mp4'
import { mobile } from '@/utils/media-query'

const CarouselContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.sectionMargin}px;
  video {
    width: 100%;
  }

  ${mobile.css`
        margin-bottom: ${({ theme }) => theme.sectionMobileMargin}px;
        overflow: hidden;
        width: 100%;

        video {
            width: unset;
            height: 430px;
        }
    `}
`

export const GifCarousel = () => (
  <CarouselContainer>
    <video autoPlay loop muted playsInline>
      <source src={gifCarouselSrc} type="video/mp4" />
    </video>
  </CarouselContainer>
)
